module.exports = __webpack_public_path__ + "img/collection_icon.0de35654.svg";